import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VDialog,{attrs:{"max-width":_vm.maxWidth,"persistent":""},model:{value:(_vm.globalDialog),callback:function ($$v) {_vm.globalDialog=$$v},expression:"globalDialog"}},[_c(VCard,[_c(VCardTitle,{staticClass:"text-h5 lighten-2",style:(_vm.getThemeStyle)},[_vm._v(_vm._s(_vm.title))]),_c(VCard,{staticClass:"mt-6 mx-4"},[_vm._t("default")],2),_c(VDivider),_c(VCardActions,[_c(VSpacer),_c('vButton',{staticClass:"mb-4",attrs:{"icon":"mdi-close","color":"red","label":"Close","small":true},on:{"button-clicked":_vm.closeGlobalDialogSlot}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }